import angular from 'angular';
import display from './builder/display.html';
import query from './builder/query.html';
import validate from './builder/validate.html';

angular.module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/ktable/display.html', display);
	$templateCache.put('kform/components/ktable/query.html', query);
	$templateCache.put('kform/components/ktable/validate.html', validate);
});
